/* ==========================================================================
   MERCH EXPRESS: HOLIDAY LAYER (decorations)
   --------------------------------------------------------------------------
   Adds the seasonal decorations to the existing page chrome, so the normal
   sections stay untouched and the whole layer comes off by switching
   Theme settings > Holiday mode off (snippets/mx-holiday.liquid then stops
   loading this file and assets/mx-holiday.css).

   Everything added here is decorative: aria-hidden, no pointer events,
   except the "Let it snow" button, which is a real toggle.
   ========================================================================== */
(function () {
  'use strict';
  var d = document;
  var cfg = window.mxHoliday || {};
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function make(tag, cls, html) {
    var el = d.createElement(tag);
    el.className = cls;
    if (html) el.innerHTML = html;
    if (tag !== 'button') el.setAttribute('aria-hidden', 'true');
    return el;
  }

  function snow(extra) {
    return make('div', 'mxh-snow' + (extra ? ' ' + extra : ''), '<i></i><i></i>');
  }

  /* A hanging bauble: string, cap, ball. kind = orange | cream | star.
     Drawn 100 units wide; the string length sets how low it hangs. */
  var uid = 0;
  function ornament(kind, len) {
    var id = 'mxh' + (++uid);
    var R = 42, cy = len + 56, h = cy + R + 4;
    // The star has no cap: its loop sits on the top arm
    var loopY = kind === 'star' ? cy - 43 : len + 4;
    var s = '<svg viewBox="0 0 100 ' + h + '" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M50 0V' + (loopY - 2) + '" stroke="#F5EDE3" stroke-opacity=".75" stroke-width="1.4"/>' +
      '<circle cx="50" cy="' + loopY + '" r="4" fill="none" stroke="#F5EDE3" stroke-width="2"/>';
    if (kind === 'star') {
      var arms = '';
      for (var a = 0; a < 360; a += 60) {
        arms += '<g transform="rotate(' + a + ' 50 ' + cy + ')">' +
          '<path d="M50 ' + cy + 'V' + (cy - 38) + 'M50 ' + (cy - 22) + 'l-10-9M50 ' + (cy - 22) + 'l10-9' +
          'M50 ' + (cy - 10) + 'l-6-6M50 ' + (cy - 10) + 'l6-6"/></g>';
      }
      s += '<g fill="none" stroke="#FDFAF3" stroke-width="5" stroke-linecap="round">' + arms + '</g>' +
        '<circle cx="50" cy="' + cy + '" r="7" fill="#E55204"/>';
      return s + '</svg>';
    }
    var orange = kind === 'orange';
    var g0 = orange ? '#FF8A4C' : '#FFFFFF', g1 = orange ? '#E55204' : '#F5EDE3', g2 = orange ? '#A93A02' : '#D6C3AC';
    var stripe = orange ? '#FDFAF3' : '#E55204', stripeOp = orange ? '.3' : '.85';
    var lines = '';
    for (var x = -60; x < 160; x += 18) lines += '<path d="M' + x + ' ' + (cy - 60) + 'l60 120"/>';
    s += '<defs>' +
      '<radialGradient id="' + id + 'g" cx=".36" cy=".3" r=".75"><stop offset="0" stop-color="' + g0 + '"/>' +
      '<stop offset=".55" stop-color="' + g1 + '"/><stop offset="1" stop-color="' + g2 + '"/></radialGradient>' +
      '<clipPath id="' + id + 'c"><circle cx="50" cy="' + cy + '" r="' + R + '"/></clipPath></defs>' +
      '<rect x="41" y="' + (len + 7) + '" width="18" height="11" rx="2.5" fill="#F5EDE3"/>' +
      '<path d="M41 ' + (len + 12) + 'h18" stroke="#051C2C" stroke-opacity=".25" stroke-width="1.2"/>' +
      '<circle cx="50" cy="' + cy + '" r="' + R + '" fill="url(#' + id + 'g)"/>' +
      '<g clip-path="url(#' + id + 'c)" stroke="' + stripe + '" stroke-opacity="' + stripeOp + '" stroke-width="6">' + lines + '</g>' +
      '<circle cx="50" cy="' + cy + '" r="' + R + '" fill="none" stroke="#000" stroke-opacity=".12" stroke-width="1.5"/>' +
      '<ellipse cx="36" cy="' + (cy - 16) + '" rx="9" ry="13" transform="rotate(30 36 ' + (cy - 16) + ')" fill="#fff" opacity=".45"/>';
    return s + '</svg>';
  }

  /* Santa's sleigh and four reindeer, drawn inline so each part can move on
     its own: the reindeer bob out of step with galloping legs, the sleigh
     rocks, Rudolph's nose pulses, and stardust streams off the back.
     Silhouettes in navy like the skyline; Santa's beard, face, hat trim and
     pompom in white and cream so he reads at a glance. */
  var SANTA_VIEW = '-130 -34 690 140';
  var SLEIGH_AT = [55, 60];           // sleigh centre / bottom, in the viewBox
  function santa() {
    var N = '#051C2C', W = '#FFFFFF', C = '#F5EDE3', O = '#E55204';
    function deer(tx, ty, prev, i, nose) {
      var leg = ' fill="none" stroke="' + N + '" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round"';
      var ant = ' fill="none" stroke="' + N + '" stroke-width="2.3" stroke-linecap="round"';
      return '<g class="mxh-deer mxh-deer--' + i + '">' +
        '<path d="M' + (tx + 22) + ' ' + (ty + 1) + 'L' + prev[0] + ' ' + prev[1] + '" stroke="' + N + '" stroke-width="1.6" fill="none"/>' +
        '<g transform="translate(' + tx + ' ' + ty + ')">' +
          // body, neck and head in one outline: rump, back, withers, neck,
          // forehead, muzzle, rounded nose, jaw, throat, chest, belly
          '<path d="M-30-4C-30-10-22-12-12-11C0-10 8-12 16-13C21-18 25-24 28-29C30-32 34-32 37-31' +
            'L44-28.5C47-27.5 48-24.5 45.5-23L38-21.5C34-21 31-19 29-16C27-11 26-6 25-2' +
            'C24 3 18 7 8 7C-4 8-18 8-26 5C-31 3-32 0-30-4Z"/>' +
          '<path d="M33-30.5L28-37L35.5-32Z"/>' +                        // ear
          '<path d="M-29-6L-36-10L-31-2Z"/>' +                           // tail
          '<g class="mxh-deer__front"><path d="M19 3L27 10L35 8M15 5L22 14L31 15"' + leg + '/></g>' +
          '<g class="mxh-deer__hind"><path d="M-22 4L-32 9L-42 7M-25 1L-36 2L-45-2"' + leg + '/></g>' +
          '<path d="M33-32C31-40 27-44 21-47M30.5-39L35-45M27.5-43L29-50M24-45.5L22.5-51' +
            'M35.5-32C36-40 34-45 31-49M35-40L40-44"' + ant + '/>' +
          (nose ? '<circle class="mxh-nose" cx="46.5" cy="-24.5" r="11" fill="#FFB27A" opacity=".4"/>' +
            '<circle cx="46.5" cy="-24.5" r="6" fill="#FF8A4C" opacity=".65"/>' +
            '<circle cx="46.5" cy="-24.5" r="3.3" fill="#FF6B1F"/><circle cx="45.6" cy="-25.4" r="1.1" fill="#fff"/>' : '') +
        '</g></g>';
    }
    var herd = [[204, 56], [296, 46], [388, 36], [480, 26]], prev = [96, 31], deers = '';
    herd.forEach(function (h, i) {
      deers += deer(h[0], h[1], prev, i + 1, i === 3);
      prev = [h[0] + 22, h[1] + 1];
    });
    var dust = '';
    for (var k = 0; k < 16; k++) {
      var r = (1.2 + (k * 7 % 5) * .35).toFixed(1);
      dust += '<circle cx="4" cy="' + (50 + (k * 5 % 12)) + '" r="' + r + '" style="--dx:' + (-110 - (k * 13 % 40)) + 'px;--dy:' + (12 + (k * 11 % 24)) + 'px;animation-delay:' + (-k * .12).toFixed(2) + 's"/>';
    }
    var sleigh =
      '<g class="mxh-sleigh">' +
        // sack with presents peeking out
        '<path d="M12 36C4 18 14 2 28 4C42 2 50 18 44 36Z" fill="' + N + '"/>' +
        '<rect x="19" y="-4" width="11" height="10" rx="1" fill="' + C + '"/><path d="M24.5-4V6M19 1H30" stroke="' + O + '" stroke-width="2.2"/>' +
        '<rect x="30" y="-1" width="9" height="8" rx="1" fill="' + O + '"/><path d="M34.5-1V7M30 3H39" stroke="' + C + '" stroke-width="1.8"/>' +
        '<path d="M22 6C26 9 32 9 38 6" stroke="' + C + '" stroke-width="2" fill="none" stroke-linecap="round"/>' +
        // Santa: coat, arm on the reins, face, beard, hat with trim and pompom
        '<path d="M48 44C46 28 52 19 64 19C75 19 81 27 80 44Z" fill="' + N + '"/>' +
        '<path d="M74 25C82 26 88 28 94 31" stroke="' + N + '" stroke-width="6" stroke-linecap="round" fill="none"/>' +
        '<path d="M86.5 26.5L88 32" stroke="' + W + '" stroke-width="3" stroke-linecap="round"/>' +
        '<circle cx="95" cy="31.5" r="3.6" fill="' + N + '"/>' +
        '<circle cx="68.5" cy="12" r="6.6" fill="' + C + '"/>' +
        '<path d="M61.5 12.5C60.5 22 64 29 70 30C76.5 29 79.5 22 76.5 13C74 16 71.5 17.2 69 17.2C66 17.2 63.5 15.5 61.5 12.5Z" fill="' + W + '"/>' +
        '<path d="M66.5 15.5C68 14.4 70 14.4 71 15.5C72 14.4 74.2 14.4 75.4 15.6C73.6 17.6 71.6 17 71 16.4C70 17.2 67.8 17.4 66.5 15.5Z" fill="' + W + '"/>' +
        '<circle cx="72.4" cy="13.4" r="1.6" fill="#E8B49A"/><circle cx="71" cy="10" r=".95" fill="' + N + '"/>' +
        '<path d="M61.5 7C61-1 66-5 73-3.5C77-2.6 78 2 77 7Z" fill="' + N + '"/>' +
        '<path d="M64 0C58-2.5 52.5-.5 50.5 5.5L54.5 6C56 3 59 1.8 63.5 3Z" fill="' + N + '"/>' +
        '<rect x="60" y="5" width="18.5" height="4.8" rx="2.4" fill="' + W + '"/>' +
        '<circle cx="51.2" cy="7.2" r="3.2" fill="' + W + '"/>' +
        // sleigh: high back, seat dip, rising curled front, brand-orange trim
        '<path d="M8 28H32C40 28 44 40 52 40H96C100 40 102 36 102 28H108C108 46 98 60 80 60H24C12 60 6 48 8 28Z" fill="' + N + '"/>' +
        '<path d="M108 30C109 21 103 18 99.5 21.5C96.5 24.5 99 29 103 27.5" fill="none" stroke="' + N + '" stroke-width="3.6" stroke-linecap="round"/>' +
        '<path d="M15 51H92" stroke="' + O + '" stroke-width="2.4" stroke-linecap="round"/>' +
        '<path d="M0 72H90C102 72 110 66 112 56C113 50 108 48 105 51" fill="none" stroke="' + N + '" stroke-width="4" stroke-linecap="round"/>' +
        '<path d="M26 60V72M76 60V72" stroke="' + N + '" stroke-width="4"/>' +
      '</g>';
    return '<svg viewBox="' + SANTA_VIEW + '" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<g class="mxh-dust" fill="#fff">' + dust + '</g>' +
      '<g fill="' + N + '">' + deers + '</g>' + sleigh + '</svg>';
  }

  /* Santa delivers across the whole city: as the sleigh passes over a house
     it drops a present (two over the Calgary Tower), which tumbles down past
     the buildings to the snowy ground, lands upright with a small bounce and
     fades. The drop points come from the skyline drawing itself (written in
     by build_holiday_css.py), in skyline units of 2400x300. Checked once a
     frame while the footer is on screen (reads only). */
  /* CITY_ROOFS:start */ var CITY_ROOFS = [[70,240,1],[235,224,1],[420,230,1],[627,203,1],[826,158,1],[996,158,1],[1100,50,2],[1340,100,1],[1607,185,1],[1816,205,1],[2011,224,1],[2217,246,1]]; /* CITY_ROOFS:end */
  function giftSvg(box, ribbon) {
    var o = ' stroke="#051C2C" stroke-opacity=".5" stroke-width=".8"';
    return '<svg viewBox="0 0 24 26" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M12 7C9 2 4 2 4.5 5.5 5 8 9 7.5 12 7ZM12 7C15 2 20 2 19.5 5.5 19 8 15 7.5 12 7Z" fill="' + ribbon + '"' + o + '/>' +
      '<rect x="2" y="7" width="20" height="5" rx="1" fill="' + box + '"' + o + '/>' +
      '<rect x="3.5" y="12" width="17" height="12" rx="1" fill="' + box + '"' + o + '/>' +
      '<path d="M12 7V24" stroke="' + ribbon + '" stroke-width="3"/></svg>';
  }
  var GIFTS = [giftSvg('#FDFAF3', '#E55204'), giftSvg('#E55204', '#FDFAF3'), giftSvg('#051C2C', '#FF8A4C'),
    giftSvg('#FDFAF3', '#051C2C'), giftSvg('#FF6B1F', '#FDFAF3')];
  var GIFT_GAP = 240;   // ms between the presents for one rooftop
  function giftDrops(foot, sky, city) {
    var view = SANTA_VIEW.split(' ').map(Number);
    var fx = (SLEIGH_AT[0] - view[0]) / view[2], fy = (SLEIGH_AT[1] - view[1]) / view[3];
    var done = {}, lastX = -1e9, n = 0, visible = false, raf = 0;
    function spot(t) {            // above the house, and the ground below it
      var r = city.getBoundingClientRect(), u = r.height / 300;
      return { x: r.left + (r.width - 2400 * u) / 2 + t[0] * u, ground: r.bottom - 6 * u };
    }
    function where() {
      var s = sky.getBoundingClientRect();
      return { x: s.left + s.width * fx, y: s.top + s.height * fy, w: s.width };
    }
    // One present, released from wherever the sleigh is now, falling to the
    // ground in front of that house (a little apart when it gets two)
    function drop(t, k) {
      var f = foot.getBoundingClientRect(), p = where(), r = spot(t), i = n++;
      var aim = r.x + (k ? (k % 2 ? 6 : -6) : 0);
      var g = make('span', 'mxh-gift', GIFTS[i % GIFTS.length]);
      g.style.left = (p.x - f.left) + 'px';
      g.style.top = (p.y - f.top) + 'px';
      g.style.setProperty('--fall', Math.max(30, r.ground - p.y) + 'px');
      g.style.setProperty('--drift', (aim - p.x) + 'px');
      g.style.setProperty('--spin', (i % 2 ? -1 : 1) * (i % 3 ? 360 : 720) + 'deg');   // whole turns: lands upright
      g.style.setProperty('--size', (.82 + (i * 37 % 5) * .06).toFixed(2));
      foot.appendChild(g);
      setTimeout(function () { g.remove(); }, 2700);
    }
    function tick() {
      raf = 0;
      if (!visible) return;
      var p = where(), f = foot.getBoundingClientRect();
      if (p.x < lastX - 100) done = {};             // a new pass has started
      lastX = p.x;
      var lead = p.w * .15;                         // release a little before the roof
      for (var i = 0; i < CITY_ROOFS.length; i++) {
        var t = CITY_ROOFS[i];
        if (done[i]) continue;
        var r = spot(t);
        if (r.x < f.left + 10 || r.x > f.right - 10) continue;   // off screen
        if (p.x >= r.x - lead && p.x < r.x) {
          done[i] = true;
          for (var k = 0; k < t[2]; k++) setTimeout(drop.bind(null, t, k), k * GIFT_GAP);
        }
      }
      raf = requestAnimationFrame(tick);
    }
    if (!window.IntersectionObserver) return;
    new IntersectionObserver(function (e) {
      visible = e[0].isIntersecting;
      if (visible && !raf) raf = requestAnimationFrame(tick);
    }).observe(foot);
  }

  var flakeIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true">' +
    '<path d="M12 2v20M3.3 7l17.4 10M3.3 17l17.4-10"/>' +
    '<path d="M9.5 3.8 12 6l2.5-2.2M9.5 20.2 12 18l2.5 2.2M4.1 10.4l3.2-.9-.9-3.2M19.9 13.6l-3.2.9.9 3.2M4.1 13.6l3.2.9-.9 3.2M19.9 10.4l-3.2-.9.9-3.2"/></svg>';

  function init() {
    // 1. String lights under the nav bar (every page)
    var bar = d.querySelector('.mx-head__bar');
    if (bar && !bar.querySelector('.mxh-lights')) {
      bar.appendChild(make('div', 'mxh-lights', '<span></span><span class="mxh-lights__a"></span><span class="mxh-lights__b"></span>'));
    }

    // 2. Homepage hero: snow, hanging ornaments, a drift on the bottom edge
    var hero = d.querySelector('.mx-hero');
    if (hero && !hero.querySelector('.mxh-hero')) {
      var deco = make('div', 'mxh-hero');
      deco.appendChild(snow());
      var orns = make('div', 'mxh-orns');
      [['orange', 150], ['cream', 120], ['star', 200], ['orange', 110]].forEach(function (o, i) {
        orns.appendChild(make('span', 'mxh-orn mxh-orn--' + (i + 1), ornament(o[0], o[1])));
      });
      deco.appendChild(orns);
      deco.appendChild(make('div', 'mxh-drift'));
      hero.appendChild(deco);
    }

    // 3. Collection banners: drifting snowflake crystals behind the copy.
    //    On wide screens the banner is narrower than the window, so a second
    //    layer sits behind it to fill the full width. Both are sized to the
    //    full-width page wrapper and share its left edge as their origin, so
    //    the flakes line up across the banner's edge.
    var ch = d.querySelector('.mx-collection-hero');
    if (ch && !ch.querySelector('.mxh-snow')) {
      var inner = snow('mxh-snow--crystal mxh-snow--crystal-in');
      var outer = snow('mxh-snow--crystal mxh-snow--crystal-out');
      var holder = ch.parentElement;
      var page = ch.closest('.mx-collection') || holder;
      ch.insertBefore(inner, ch.firstChild);
      holder.insertBefore(outer, holder.firstChild);
      var fit = function () {
        var p = page.getBoundingClientRect(), h = ch.getBoundingClientRect(), o = holder.getBoundingClientRect();
        var hs = getComputedStyle(holder);
        if (hs.position === 'static') holder.style.position = 'relative';
        inner.style.left = (p.left - h.left) + 'px';
        inner.style.width = p.width + 'px';
        outer.style.left = (p.left - o.left) + 'px';
        outer.style.top = (h.top - o.top) + 'px';
        outer.style.width = p.width + 'px';
        outer.style.height = h.height + 'px';
      };
      fit();
      if (window.ResizeObserver) new ResizeObserver(fit).observe(ch);
      else window.addEventListener('resize', fit);
    }

    // 4. Footer: the Calgary skyline behind the content, falling snow,
    //    and the holiday greeting in the copyright row
    var foot = d.querySelector('footer.custom-footer');
    if (foot && !foot.querySelector('.mxh-city')) {
      foot.insertBefore(snow('mxh-footsnow'), foot.firstChild);
      var sky = make('div', 'mxh-santa', '<i>' + santa() + '</i>');
      var city = make('div', 'mxh-city');
      foot.insertBefore(sky, foot.firstChild);
      foot.insertBefore(city, foot.firstChild);
      if (!reduceMotion) giftDrops(foot, sky, city);
      var bottom = foot.querySelector('.footer-bottom');
      if (bottom && cfg.footerLine) {
        var line = d.createElement('p');
        line.className = 'mxh-footer-line';
        line.innerHTML = flakeIcon + '<span></span>' + flakeIcon;
        line.querySelector('span').textContent = cfg.footerLine;
        bottom.insertBefore(line, bottom.firstChild);
      }
    }

    // 5. "Let it snow": optional snowfall over the whole site, remembered per visitor
    if (cfg.snowButton && !reduceMotion && !d.querySelector('.mxh-snowbtn')) {
      var layer = make('div', 'mxh-sitesnow', '<i></i><i></i>');
      var btn = make('button', 'mxh-snowbtn');
      btn.type = 'button';
      btn.innerHTML = flakeIcon + '<span></span>';
      var label = btn.querySelector('span');
      var key = 'mxh-site-snow';
      function set(on) {
        layer.classList.toggle('is-on', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        label.textContent = on ? 'Stop the snow' : 'Let it snow';
        try { localStorage.setItem(key, on ? '1' : '0'); } catch (e) {}
      }
      btn.addEventListener('click', function () { set(btn.getAttribute('aria-pressed') !== 'true'); });
      var saved = null;
      try { saved = localStorage.getItem(key); } catch (e) {}
      d.body.appendChild(layer);
      d.body.appendChild(btn);
      set(saved === '1');
    }
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init);
  else init();
})();
